import { render } from "./individual_bank_account_form.html?vue&type=template&id=d626f0d8&external"
import script from "./individual_bank_account_form.js?vue&type=script&lang=js&external"
export * from "./individual_bank_account_form.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__